import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";
import { getDropdownContractsAction } from "../../../../../redux/actions/contractActions";
import { useCustomHook } from "../../../../GlobalFunctions/globalFunctions";

const Contract = ({ formik, modalData, updateModalState }) => {
  const dispatch = useDispatch();
  const { contracts } = useSelector((state) => state.contracts);
  const { contractTypesList } = useCustomHook();
  const [openDropdown, setOpenDropdown] = useState(false);

  const inputValue =
    contractTypesList.find(
      (item) => item.key === modalData?.contract?.contractType,
    )?.name || "";

  const addData = (item) => {
    updateModalState("contract", item);
    setOpenDropdown(false);
  };

  useEffect(() => {
    if (openDropdown) {
      dispatch(getDropdownContractsAction());
    }
  }, [openDropdown]);
  return (
    <>
      <div className="class-input">
        <div className="dropdown-input">
          <div className="input-box">
            <TextField
              sx={{
                "& input": {
                  fontSize: "12px",
                  marginRight: "32px",
                },
                marginTop: "24px",
                // marginBottom: "24px",
                // "& .MuiInputLabel-root.Mui-required:after": {
                //   content: '" *"',
                //   color: "red",
                //   fontSize: "12px",
                // },
              }}
              InputLabelProps={{
                style: { fontSize: "12px", color: "#3F3F3F" },
              }}
              fullWidth
              label="Satış növü"
              autoComplete="off"
              disabled
              value={inputValue}
              onBlur={() => formik.setFieldTouched("contract", true)}
              required={false}
            />
            <DropdownIcon
              setOpenDropdown={setOpenDropdown}
              openDropdown={openDropdown}
            />
          </div>

          <ul
            className={`dropdown-body where-coming ${
              openDropdown ? "active" : ""
            }`}
          >
            {contracts.map((contract) => (
              <li key={contract._id} onClick={() => addData(contract)}>
                <h4>
                  {contractTypesList.find(
                    (item) => item.key === contract.contractType,
                  )?.name || "null"}
                </h4>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {formik.errors.contract && formik.touched.contract && (
        <small className="validation-err-message">
          {formik.errors.contract}
        </small>
      )}
    </>
  );
};

export default Contract;
